import { KeyValueStorage } from 'record-it-utils/dataStorage/KeyValueStorage';
import { DisposableCollection } from 'record-it-utils/misc/DisposableCollection/DisposableCollection';
import { Disposable } from 'record-it-utils/utils/DisposableContainer/DisposableContainer';
export class StorageClearer {
  private static beforeClearTasks = new DisposableCollection<StorageClearerTask>();
  private static afterClearTasks = new DisposableCollection<StorageClearerTask>();
  private constructor() {}
  public static async clear(): Promise<void> {
    await this.executeTasks(this.beforeClearTasks);
    await KeyValueStorage.clearAll();
    await this.executeTasks(this.afterClearTasks);
  }
  public static registerBeforeClearTask(task: StorageClearerTask): Disposable {
    return this.beforeClearTasks.add(task);
  }
  public static registerAfterClearTask(task: StorageClearerTask): Disposable {
    return this.afterClearTasks.add(task);
  }
  private static async executeTasks(collection: DisposableCollection<StorageClearerTask>): Promise<void> {
    for (const task of collection.toArray()) {
      await task();
    }
  }
}
export type StorageClearerTask = () => void | Promise<void>;